import service from './service';

export default {
  // 获取我的招聘信息列表
  getInfoList(params) {
    return service({
      url: '/api/v1/info/list',
      method: 'get',
      params
    });
  },
  // 删除职位
  deleteRecruit(id) {
    return service({
      url: `/api/v1/info/${id}/delete`,
      method: 'delete'
    })
  },
  // 重新发布
  reRefreshRecruit(id) {
    return service({
      url: `/api/v1/info/${id}/re-refresh`,
      method: 'put'
    })
  },
  // 刷新
  refreshRecruit(id) {
    return service({
      url: `/api/v1/info/${id}/refresh`,
      method: 'put'
    })
  },
  // 自动刷新
  autoRefreshRecruit(id, refreshCron) {
    return service({
      url: `/api/v1/info/${id}/auto/refresh`,
      method: 'put',
      data: {
        refresh_cron: refreshCron
      }
    })
  },
  // 置顶
  topRecruit0(info) {
    return service({
      url: `/api/v1/info/${info.id}/top/step0`,
      method: 'post',
      data: {
      }
    })
  },
  // 置顶
  topRecruit(info) {
    return service({
      url: `/api/v1/info/${info.id}/top/step1`,
      method: 'post',
      data: {
        days: info.days,
        password: info.password
      }
    })
  },
  // 置顶
  topRecruitStep2(info) {
    return service({
      url: `/api/v1/info/${info.id}/top/step2`,
      method: 'post',
      data: {
        days: info.days,
        password: info.password
      }
    })
  },
  // 停止
  stopRecruit(id) {
    return service({
      url: `/api/v1/info/${id}/stop`,
      method: 'put'
    })
  },
  // 发布招聘
  postInfoPost(info) {
    return service({
      url: '/api/v1/info/create',
      method: 'post',
      data: info
    });
  },
  // 发布招聘
  patchInfoPost(info) {
    return service({
      url: `/api/v1/info/${info.id}`,
      method: 'patch',
      data: info
    });
  },
  // 获取工作类型
  getWorkType() {
    return service.get('/api/v1/info/worktype/list');
  },

  // 获取经验列表
  getWorkExps() {
    return service.get('/api/v1/info/workexps/list');
  },

  // 获取学历列表
  getEdus() {
    return service.get('/api/v1/info/edus/list');
  },
  // 获取性别列表
  getGender() {
    return service.get('/api/v1/info/gender/list');
  },

  // 获取招聘区域列表
  // getRegion() {
  //   return service.get('/api/v1/info/region/list');
  // },

  // 获取分类小分类
  getInfoCategory(subareaId) {
    return service.get(`/api/v1/info/${subareaId}/category`);
  },

  // 获取招聘信息大分类
  getsubareaList() {
    return service.get('/api/v1/info/subarea/list');
  },

  createUpdatesStep1() {
    return service.post(`/api/v1/company/buy/createupdates/step1`);
  },

  createUpdatesStep2() {
    return service.post('/api/v1/company/buy/createupdates/step2');
  },

  preTitles() {
    return service.get('/api/v1/company/pre-titles');
  },

  createUpdateCount() {
    return service.get('/api/v1/company/todayfree/create-update-count');
  },

  deleteTop(id) {
    return service({
      url: `/api/v1/info/${id}/top/delete`,
      method: 'delete'
    })
  },
  getAddress() {
    return service.get('/api/v1/web/dictcate')
  }
};



// WEBPACK FOOTER //
// ./src/api/enterprise-recruit.js